import {useState, useCallback, useMemo} from 'react';

export const useDynamicSnapPoints = (defaultHeight = 450) => {
  const [contentHeight, setContentHeight] = useState(defaultHeight);

  const snapPoints = useMemo(() => {
    if (contentHeight === 0) {
      return [defaultHeight];
    }
    return [contentHeight + 50];
  }, [contentHeight]);

  let heightTemp = defaultHeight;

  const handleContentLayout = useCallback((event) => {
    const {height} = event.nativeEvent.layout;
    heightTemp = Math.min(height, heightTemp);
    setContentHeight(heightTemp);
  }, []);

  return {snapPoints, handleContentLayout};
};
